import { ProviderPlanId } from '__generated__/GQL';
import { SelectedProviderPlanId } from 'features/Insurance/types';

import locales from './locales';

export const insurancePlanNumbers: Record<SelectedProviderPlanId, number> = {
  [ProviderPlanId.Business]: 30,
  [ProviderPlanId.Pro]: 7,
  [ProviderPlanId.Plus]: 3,
  [ProviderPlanId.Basic]: 3,
};

export const insurancePlanDaysOrNights: Record<SelectedProviderPlanId, string> =
  {
    [ProviderPlanId.Business]: locales.content.days,
    [ProviderPlanId.Pro]: locales.content.nights,
    [ProviderPlanId.Plus]: locales.content.nights,
    [ProviderPlanId.Basic]: locales.content.nights,
  };
